import { useState, useEffect } from 'react';
import { MOBILE_SCREEN_SIZE } from '../common/constants/constants';

export const useIsMobile = (breakpoint = MOBILE_SCREEN_SIZE) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};
